import React from 'react'

import { NotificationInfoFragment } from '@sketch/gql-types'

import { WorkspaceTile } from './FolderNotificationPreview.styles'
import {
  Card,
  IconTile,
  Separator,
  Tile,
  TileTitle,
  TileWrapper,
} from './TileCard.styles'

interface FolderNotificationPreviewProps {
  /** Glyph shown in the left icon tile (e.g. an archive box or a trash can). */
  glyph: React.ReactNode
  /**
   * Name of the folder the notification is about. Omitted for permanently-
   * deleted folders — they no longer exist, so the icon tile stands unlabelled.
   */
  folderName?: string | null
  workspace: NotificationInfoFragment['workspace']
}

/**
 * Shared preview card for folder lifecycle notifications (archived, trashed,
 * permanently deleted). They differ only in the glyph and whether a folder name
 * is available, so the layout — an icon tile beside the owning workspace — lives
 * here once.
 */
export const FolderNotificationPreview = ({
  glyph,
  folderName,
  workspace,
}: FolderNotificationPreviewProps) => (
  <Card>
    <TileWrapper>
      <Tile>
        <IconTile aria-hidden>{glyph}</IconTile>
        {folderName && <TileTitle>{folderName}</TileTitle>}
      </Tile>

      <Separator />

      <Tile>
        <WorkspaceTile
          size="88px"
          workspaceName={workspace?.name}
          src={workspace?.avatar?.small}
        />
        {workspace?.name && <TileTitle>{workspace.name}</TileTitle>}
      </Tile>
    </TileWrapper>
  </Card>
)
